// extracted by mini-css-extract-plugin
export default {"closeIconContainer":"SheetCloseButton_closeIconContainer__+8eHX","close":"SheetCloseButton_close__Mfcw7"};